export { useNewMorphemeLessonPageNavigator } from "#use-new-morpheme-lesson-page-navigator";
